import { io } from "socket.io-client";
import { get } from "./cookies";
import UserAgent from "user-agents";

const userAgent = new UserAgent();

const socket = io(
  `wss://api.analytics.stuffyoucanuse.org?app=${process.env.REACT_APP_SITE_ID}`,
  {
    transports: ["websocket", "polling", "flashsocket"],
  }
);
const network = get("remote_info");

let sBrowser;
const sUsrAg = navigator.userAgent;
if (sUsrAg.indexOf("Firefox") > -1) {
  sBrowser = "firefox";
} else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
  sBrowser = "Samsung Internet";
} else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
  sBrowser = "opera";
} else if (sUsrAg.indexOf("Trident") > -1) {
  sBrowser = "Microsoft Internet Explorer";
} else if (sUsrAg.indexOf("Edge") > -1) {
  sBrowser = "Microsoft Edge (Legacy)";
} else if (sUsrAg.indexOf("Edg") > -1) {
  sBrowser = "edge";
} else if (sUsrAg.indexOf("Chrome") > -1) {
  sBrowser = "chrome";
} else if (sUsrAg.indexOf("Safari") > -1) {
  sBrowser = "safari";
} else {
  sBrowser = "unknown";
}

const getDeviceType = type => {
  const ua = type;
  let platform;
  if (/Tablet|iPad|iPod/.test(ua)) {
    platform = "tablet";
  } else if (/iPad|iPhone|iPod/.test(ua)) {
    platform = "ios";
  } else if (
    /Android|android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    platform = "android";
  } else {
    platform = "web";
  }
  return platform;
};

const getOSName = () => {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (!os && /Linux/.test(platform)) {
    os = "Linux";
  }
  return os;
};

let Obj = {
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  userAgent: JSON.stringify(userAgent.data),
  screen: {
    availHeight: window.screen.availHeight,
    availWidth: window.screen.availWidth,
    colorDepth: window.screen.colorDepth,
    height: window.screen.height,
    pixelDepth: window.screen.pixelDepth,
    width: window.screen.width,
  },
  vendor: window.navigator.vendor,
  platform: window.navigator.platform,
  deviceMemory: window.navigator.deviceMemory,
  languages: window.navigator.languages,
  network: null,
  browserName: sBrowser,
  browserPlatform: getDeviceType(sBrowser),
  operatingSystem: getOSName(),
};

socket.on("__replay", d => localStorage.setItem("_aid", d));

const sendData = async (user_id, time, ip_info) => {
  Obj.totalTime = time;
  Obj.network = ip_info;

  let a = {
    _aid: localStorage.getItem("_aid"),
    spend: time,
    _sid: socket.id,
  };

  // user &&
  socket.emit(
    "Activity",
    JSON.stringify({
      activity: a,
      data: {
        token: get("token"),
        page_title: document.title,
        page_path: window.location.pathname,
        total_time: time,
        site_id: process.env.REACT_APP_SITE_ID,
        user_id: user_id,
        ua: Obj,
        network: ip_info,
      },
    })
  );
};

const connectMainIo = () => {
  const socketConnection = socket.connect();
  socketConnection.on("connect", function () {});
};

// Single Client Data
// onclick Function tobe impliment
socket.on("LiveFeed", data => {
  socket.emit("ping", { rsid: socket.id, usid: "KH3Qmnc83akP_6i3AAAF" });
});

socket.on("listening", () => {
  socket.emit("replay", {
    data: {
      token: get("token"),
      page_title: document.title,
      page_path: window.location.pathname,
      site_id: process.env.REACT_APP_SITE_ID,
      ua: Obj,
      network: network,
    },
  });
});

socket.on("connect_error", error => {
  console.log("websocket connection error");
});
// END Single Client Data

export { connectMainIo, sendData, socket };
